/** Portfolio / Work catalogue. Bilingual fields: { en, lv } or plain string. */
const L = (en, lv) => ({ en, lv });
const M = (value, en, lv) => ({ value, label: L(en, lv) });

const portfolioEvidence = {
  classreflect: {
    metric: M('4', 'feedback workflows', 'atgriezeniskās saites plūsmas'),
    techStack: ['React', 'Node.js', L('AI transcription', 'AI transkripcija'), L('LLM analysis', 'LLM analīze'), 'Docker'],
  },
  eladore: {
    metric: M('4', 'commerce workflows', 'e-komercijas plūsmas'),
    techStack: [
      L('Custom storefront', 'Pielāgota veikala saskarne'),
      L('Product configuration', 'Produktu konfigurācija'),
      L('Checkout', 'Pirkuma plūsma'),
      'CMS',
      L('Responsive UI', 'Responsīvs UI'),
    ],
  },
  sellgames: {
    metric: M('5', 'event modules', 'pasākumu moduļi'),
    techStack: [
      L('Event CMS', 'Pasākumu CMS'),
      L('Registration flows', 'Reģistrācijas plūsmas'),
      L('Schedules', 'Grafiki'),
      L('Role administration', 'Lomu administrēšana'),
      L('Public frontend', 'Publiskā saskarne'),
    ],
  },
  invoicesuite: {
    metric: M('4', 'billing modules', 'rēķinu moduļi'),
    techStack: [
      L('SaaS backend', 'SaaS backend'),
      L('Quotes and invoices', 'Piedāvājumi un rēķini'),
      L('Recurring billing', 'Regulārā izrakstīšana'),
      L('Reporting', 'Atskaites'),
      L('Multi-tenant data model', 'Multi-tenant datu modelis'),
    ],
  },
  findstorage: {
    metric: M('4', 'search dimensions', 'meklēšanas dimensijas'),
    techStack: [
      L('Marketplace search', 'Tirgus meklēšana'),
      L('Listing CMS', 'Sludinājumu CMS'),
      L('Location and size filters', 'Vietas un izmēra filtri'),
      L('Enquiry routing', 'Pieprasījumu maršrutēšana'),
      'SEO',
    ],
  },
  quiz: {
    metric: M('4', 'assessment workflows', 'vērtēšanas plūsmas'),
    techStack: [
      L('Question banks', 'Jautājumu bankas'),
      L('Timed runs', 'Laika limiti'),
      L('Auto-grading', 'Automātiska vērtēšana'),
      L('Results analytics', 'Rezultātu analītika'),
      L('Web app', 'Web lietotne'),
    ],
  },
  ticketflow: {
    metric: M('5', 'ops primitives', 'ops pamatelementi'),
    techStack: [
      L('Ticket queues', 'Pieteikumu rindas'),
      L('Priorities', 'Prioritātes'),
      L('Comments and subtasks', 'Komentāri un apakšuzdevumi'),
      L('Role access', 'Lomu piekļuve'),
      L('Workload dashboard', 'Noslodzes panelis'),
    ],
  },
  evertejumi: {
    metric: M('3', 'service flows', 'pakalpojumu plūsmas'),
    techStack: [
      L('Valuation workflows', 'Vērtēšanas plūsmas'),
      L('Guided forms', 'Vadītas formas'),
      L('Service CMS', 'Pakalpojumu CMS'),
      L('Responsive frontend', 'Responsīva saskarne'),
    ],
  },
  fullcourt: {
    metric: M('4', 'ops areas', 'operāciju zonas'),
    techStack: [
      L('Booking engine', 'Rezervāciju dzinējs'),
      L('Scheduling', 'Grafiki'),
      L('Member operations', 'Biedru operācijas'),
      L('Facility dashboards', 'Objektu paneļi'),
      L('Continuous delivery', 'Nepārtraukta piegāde'),
    ],
  },
  trukka: {
    metric: M('2', 'mobile roles', 'mobilās lomas'),
    techStack: ['Expo', 'React Native', L('Web ops console', 'Web ops konsole'), L('Live maps', 'Dzīvās kartes'), 'Stripe', L('Offline queue', 'Offline rinda')],
  },
  attendance: {
    metric: M('3', 'register screens', 'reģistra ekrāni'),
    techStack: [
      L('Android app', 'Android lietotne'),
      L('School-management sync', 'Skolu pārvaldības sinhronizācija'),
      L('Staff auth', 'Personāla autentifikācija'),
      L('Attendance register', 'Apmeklējuma reģistrs'),
      L('Multi-campus data', 'Vairāku kampusu dati'),
    ],
  },
  lusiic: {
    metric: M('3', 'registry workflows', 'reģistra plūsmas'),
    techStack: [
      L('Member registry', 'Biedru reģistrs'),
      L('Status tracking', 'Statusu izsekošana'),
      L('Admin workflows', 'Admin plūsmas'),
      L('Institutional reporting', 'Institucionālās atskaites'),
    ],
  },
  luogre: {
    metric: M('3', 'event layers', 'pasākuma slāņi'),
    techStack: [
      L('Event CMS', 'Pasākumu CMS'),
      L('Registration', 'Reģistrācija'),
      L('Programme pages', 'Programmas lapas'),
      L('Speaker content', 'Runātāju saturs'),
      L('Public frontend', 'Publiskā saskarne'),
    ],
  },
  signet: {
    metric: M('3', 'gallery workflows', 'galerijas plūsmas'),
    techStack: [
      L('Artwork catalogue', 'Darbu katalogs'),
      L('Enquiry flow', 'Pieprasījumu plūsma'),
      'CMS',
      L('Responsive frontend', 'Responsīva saskarne'),
    ],
  },
  everlasting: {
    metric: M('3', 'commerce workflows', 'e-komercijas plūsmas'),
    techStack: [
      L('Product catalogue', 'Produktu katalogs'),
      L('Checkout', 'Pirkuma plūsma'),
      'CMS',
      L('Responsive storefront', 'Responsīvs veikals'),
    ],
  },
  fieldledger: {
    metric: M('5', 'agronomy modules', 'agronomijas moduļi'),
    techStack: [
      L('Web maps', 'Web kartes'),
      L('Field boundaries', 'Lauku robežas'),
      L('Soil analysis import', 'Augsnes analīžu imports'),
      L('Zone maps', 'Zonu kartes'),
      L('Recommendation history', 'Ieteikumu vēsture'),
    ],
  },
};

export const portfolioItems = [
  {
    key: 'classreflect',
    title: 'ClassReflect',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L('AI classroom audio analysis and teaching feedback.', 'AI balstīta klases audio analīze un atgriezeniskā saite skolotājiem.'),
    about: L(
      'ClassReflect is an AI product for schools and training organisations. Lessons are recorded, transcribed and analysed so teachers get private, structured feedback without an observer in the room. Built end-to-end by GDWD — product, backend, and delivery.',
      'ClassReflect ir AI produkts skolām un apmācību organizācijām. Stundas tiek ierakstītas, transkribētas un analizētas, lai skolotāji saņemtu privātu, strukturētu atgriezenisko saiti bez novērotāja klasē. GDWD būvējis no gala līdz galam — produkts, backend un piegāde.'
    ),
    solves: L(
      'Turns classroom audio into structured teaching feedback — no observer in the room.',
      'Pārvērš klases audio strukturētā atgriezeniskajā saitē — bez novērotāja klasē.'
    ),
    features: [
      L('Automatic lesson transcription and AI analysis', 'Automātiska stundas transkripcija un AI analīze'),
      L('Teaching-quality metrics and trends per class', 'Mācīšanas kvalitātes rādītāji un tendences pa klasēm'),
      L('Private, actionable feedback for teachers', 'Privāta, praktiska atgriezeniskā saite skolotājiem'),
      L('Secure multi-tenant school setup', 'Droša multi-tenant skolu uzstādīšana'),
    ],
    chips: [L('AI', 'AI'), L('EdTech', 'EdTech')],
    cta: L('View product', 'Skatīt produktu'),
    url: 'https://classreflect.com',
    cats: ['Products', 'Education'],
    src: '/assets/portfolio/classreflect-home.png',
    gallery: [
      '/assets/portfolio/classreflect-home.png',
      '/assets/portfolio/extra/classreflect-features.png',
      '/assets/portfolio/extra/classreflect-how.png',
      '/assets/portfolio/extra/classreflect-pricing.png',
    ],
  },
  {
    key: 'eladore',
    title: 'EladoreRuffles',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L('Custom fashion e-commerce storefront.', 'Pielāgota modes e-komercijas vietne.'),
    about: L(
      'A full custom fashion store — product configuration, catalogue, checkout and brand-managed content. Not a generic theme: flows match how the brand sells made-to-order fashion.',
      'Pilns modes veikals — produktu konfigurācija, katalogs, pirkuma plūsma un zīmola pārvaldīts saturs. Nav standarta šablons: plūsmas atbilst individuālās modes pārdošanai.'
    ),
    solves: L(
      'A storefront built around a custom-fashion workflow, not a template.',
      'Veikals, kas būvēts ap individuālas modes procesu, nevis šablonu.'
    ),
    features: [
      L('Custom product configuration and ordering', 'Individuāla produktu konfigurācija un pasūtīšana'),
      L('Full checkout with payments', 'Pilna pirkuma plūsma ar maksājumiem'),
      L('Content managed by the brand team', 'Saturu pārvalda zīmola komanda'),
      L('Responsive storefront experience', 'Responsīva veikala pieredze'),
    ],
    chips: [L('E-commerce', 'E-komercija')],
    cta: L('View site', 'Skatīt vietni'),
    url: 'https://eladoreruffles.com',
    cats: ['Products', 'E-commerce'],
    src: '/assets/portfolio/eladoreruffles-home.jpg',
    gallery: [
      '/assets/portfolio/eladoreruffles-home.jpg',
      '/assets/portfolio/extra/eladore-product.jpg',
      '/assets/portfolio/extra/eladore-scroll.jpg',
      '/assets/portfolio/extra/eladore-product-gift-card.jpg',
    ],
  },
  {
    key: 'sellgames',
    title: 'Sell Games 2026',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L('Multi-event student games platform.', 'Daudzu pasākumu studentu spēļu platforma.'),
    about: L(
      'Multi-tenant event platform for a large student games programme: registration, schedules, venues and admin roles across many events in one system.',
      'Multi-tenant pasākumu platforma lielai studentu spēļu programmai: reģistrācija, grafiki, norises vietas un admin lomas vairākiem pasākumiem vienā sistēmā.'
    ),
    solves: L(
      'One platform for a multi-event student games programme — from registration to results.',
      'Viena platforma daudzu pasākumu studentu spēlēm — no reģistrācijas līdz rezultātiem.'
    ),
    features: [
      L('Event and team registration flows', 'Pasākumu un komandu reģistrācijas plūsmas'),
      L('Schedules, venues and live updates', 'Grafiki, norises vietas un aktuālā informācija'),
      L('Multi-event, multi-role administration', 'Daudzu pasākumu un lomu administrēšana'),
      L('Public-facing event experience', 'Publiska pasākuma pieredze'),
    ],
    chips: [L('Events', 'Pasākumi'), L('Multi-tenant', 'Multi-tenant')],
    cta: L('View platform', 'Skatīt platformu'),
    url: 'https://sellgames2026.com',
    cats: ['Products', 'Education'],
    src: '/assets/portfolio/sellgames2026-home.jpg',
    gallery: [
      '/assets/portfolio/sellgames2026-home.jpg',
      '/assets/portfolio/extra/sellgames-news.jpg',
      '/assets/portfolio/extra/sellgames-about.png',
      '/assets/portfolio/extra/sellgames-register.png',
      '/assets/portfolio/extra/sellgames-schedule.png',
    ],
  },
  {
    key: 'invoicesuite',
    title: 'InvoiceSuite',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L('Invoicing SaaS for freelancers and SMEs.', 'Rēķinu SaaS frīlanseriem un MVU.'),
    about: L(
      'SaaS invoicing product for freelancers and small businesses: quotes, invoices, recurring billing, clients and reports — designed for day-to-day freelancing ops.',
      'SaaS rēķinu produkts frīlanseriem un maziem uzņēmumiem: piedāvājumi, rēķini, regulārā izrakstīšana, klienti un atskaites — ikdienas frīlansa darbiem.'
    ),
    solves: L('Invoicing without the admin overhead — from quote to paid.', 'Rēķini bez administratīvā sloga — no piedāvājuma līdz apmaksai.'),
    features: [
      L('Invoices, quotes and recurring billing', 'Rēķini, piedāvājumi un regulārā izrakstīšana'),
      L('Client and payment tracking', 'Klientu un maksājumu izsekošana'),
      L('Reports ready for the accountant', 'Atskaites, kas gatavas grāmatvedim'),
      L('Built as a multi-tenant SaaS product', 'Būvēts kā multi-tenant SaaS produkts'),
    ],
    chips: [L('SaaS', 'SaaS'), L('Billing', 'Rēķini')],
    cta: L('View product', 'Skatīt produktu'),
    url: 'https://invoicesuite.io',
    cats: ['Products'],
    src: '/assets/portfolio/invoicesuite-home.png',
    gallery: [
      '/assets/portfolio/invoicesuite-home.png',
      '/assets/portfolio/extra/invoicesuite-features.png',
      '/assets/portfolio/extra/invoicesuite-pricing-page.png',
      '/assets/portfolio/extra/invoicesuite-login.png',
    ],
  },
  {
    key: 'findstorage',
    title: 'FindStorage',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L('Storage price comparison for Latvia.', 'Glabātuvju cenu salīdzināšana Latvijā.'),
    about: L(
      'Marketplace-style comparison for storage units across Latvia — search, filter by location and size, compare prices and send enquiries to providers.',
      'Salīdzināšanas platforma glabātuvēm Latvijā — meklēšana, filtri pēc vietas un izmēra, cenu salīdzinājums un pieprasījumi sniedzējiem.'
    ),
    solves: L('Compare storage prices across Latvia in one search.', 'Salīdzini glabātuvju cenas visā Latvijā vienā meklējumā.'),
    features: [
      L('Live listings and price comparison', 'Aktuāli piedāvājumi un cenu salīdzinājums'),
      L('Filters by location and size', 'Filtri pēc atrašanās vietas un izmēra'),
      L('Direct enquiries to providers', 'Tiešie pieprasījumi pakalpojumu sniedzējiem'),
      L('Consumer-facing search experience', 'Patērētājam ērta meklēšanas pieredze'),
    ],
    chips: [L('Marketplace', 'Salīdzinātājs'), L('LV', 'LV')],
    cta: L('View product', 'Skatīt produktu'),
    url: 'https://findstorage.space',
    cats: ['Products'],
    src: '/assets/portfolio/findstorage-home.jpg',
    gallery: [
      '/assets/portfolio/findstorage-home.jpg',
      '/assets/portfolio/extra/findstorage-list.png',
      '/assets/portfolio/extra/findstorage-about.png',
      '/assets/portfolio/extra/findstorage-search.jpg',
    ],
  },
  {
    key: 'quiz',
    title: 'Quiz',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L('Interactive quiz and assessment product.', 'Interaktīvs viktorīnu un vērtēšanas produkts.'),
    about: L(
      'Web product for building and running quizzes and assessments — question banks, timed runs, instant grading and results for classrooms or hiring.',
      'Web produkts viktorīnu un vērtēšanas veidošanai — jautājumu bankas, laika limiti, tūlītēja vērtēšana un rezultāti klasēm vai atlasei.'
    ),
    solves: L('Assessment that runs itself — build, share, grade.', 'Vērtēšana, kas notiek pati — izveido, izplati, novērtē.'),
    features: [
      L('Question banks and timed quizzes', 'Jautājumu bankas un viktorīnas ar laika limitu'),
      L('Instant grading and result analytics', 'Tūlītēja vērtēšana un rezultātu analītika'),
      L('Works for classrooms and hiring', 'Der klasēm un personāla atlasei'),
      L('Shareable quiz links', 'Dalāmas viktorīnu saites'),
    ],
    chips: [L('Assessment', 'Vērtēšana'), L('Web', 'Web')],
    cta: L('View product', 'Skatīt produktu'),
    url: 'https://quiz.gdwd.co.uk',
    cats: ['Products', 'Education'],
    src: '/assets/portfolio/quiz-home.png',
    gallery: [
      '/assets/portfolio/quiz-home.png',
      '/assets/portfolio/extra/quiz-login.png',
      '/assets/portfolio/extra/quiz-register.png',
    ],
  },
  {
    key: 'ticketflow',
    title: 'TicketFlow',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L(
      'Work and ticket management product — tasks, queues and operations in one flow.',
      'Darbu un pieteikumu pārvaldības produkts — uzdevumi, rindas un operācijas vienā plūsmā.'
    ),
    about: L(
      'Internal and client-facing ops product for tickets, queues and team workload. GDWD runs its own delivery on TicketFlow daily — same tool we ship to others. The public marketing surface is sign-in; product depth is inside the app.',
      'Iekšējs un klientiem pieejams ops produkts pieteikumiem, rindām un komandas noslodzei. GDWD paši ikdienā strādā uz TicketFlow — tas pats rīks, ko piegādājam citiem. Publiski redzama ir pieteikšanās; produkta dziļums ir lietotnē.'
    ),
    solves: L(
      'Keeps operational work visible — every task has an owner and a status.',
      'Darbi vienmēr redzami — katram uzdevumam ir atbildīgais un statuss.'
    ),
    features: [
      L('Tickets, queues and priorities', 'Pieteikumi, rindas un prioritātes'),
      L('Team workload overview', 'Komandas noslodzes pārskats'),
      L('We run our own operations on it daily', 'Paši uz tā darbinām savas operācijas ikdienā'),
      L('Comments, subtasks and delivery flow', 'Komentāri, apakšuzdevumi un piegādes plūsma'),
    ],
    chips: [L('Management', 'Pārvaldība'), L('Ops', 'Ops')],
    cta: L('View product', 'Skatīt produktu'),
    url: 'https://ticketflow.gdwd.co.uk',
    cats: ['Products', 'Platforms'],
    src: '/assets/portfolio/ticketflow-home.png',
    gallery: ['/assets/portfolio/ticketflow-home.png'],
  },
  {
    key: 'evertejumi',
    title: 'eVertejumi',
    kind: 'Product',
    note: L('BUILT BY GDWD', 'BŪVĒJIS GDWD'),
    blurb: L(
      'Property valuation and rental assessment product for Latvia.',
      'Nekustamā īpašuma vērtēšanas un īres novērtējuma produkts Latvijai.'
    ),
    about: L(
      'Latvia-focused product for certified property valuation and step-by-step rental property assessment — clear service flows for owners and professionals.',
      'Uz Latviju vērsts produkts sertificētai nekustamā īpašuma vērtēšanai un soli-pa-solim īres dzīvokļu novērtējumam — skaidras pakalpojumu plūsmas īpašniekiem un profesionāļiem.'
    ),
    solves: L(
      'Property valuation without opaque process — services explained end to end.',
      'Īpašuma vērtēšana bez neskaidra procesa — pakalpojumi izskaidroti no sākuma līdz galam.'
    ),
    features: [
      L('Certified real-estate valuation path', 'Sertificētas nekustamā īpašuma vērtēšanas plūsma'),
      L('Rental portfolio assessment guidance', 'Īres portfeļa novērtējuma vadlīnijas'),
      L('Built for the Latvian market', 'Veidots Latvijas tirgum'),
      L('Clear public service experience', 'Skaidra publiskā pakalpojumu pieredze'),
    ],
    chips: [L('Valuation', 'Vērtēšana'), L('LV', 'LV')],
    cta: L('View product', 'Skatīt produktu'),
    url: 'https://evertejumi.lv',
    cats: ['Products'],
    src: '/assets/portfolio/evertejumi-home.png',
    gallery: [
      '/assets/portfolio/evertejumi-home.png',
      '/assets/portfolio/extra/evertejumi-scroll.png',
    ],
  },
  {
    key: 'fullcourt',
    title: 'FullCourt',
    kind: 'Platform',
    blurb: L(
      'Sports and facility operations platform — engineering and feature delivery.',
      'Sporta un infrastruktūras operāciju platforma — izstrāde un funkciju piegāde.'
    ),
    about: L(
      'Platform engineering and feature delivery for sports venue operations: bookings, facility ops and member-facing flows. Continuous delivery rather than a one-off website.',
      'Platformas izstrāde un funkciju piegāde sporta objektu operācijām: rezervācijas, infrastruktūra un biedru plūsmas. Nepārtraukta piegāde, nevis vienreizēja mājaslapa.'
    ),
    solves: L(
      'Keeps courts, bookings and facility operations running daily.',
      'Nodrošina laukumu, rezervāciju un infrastruktūras ikdienas darbu.'
    ),
    features: [
      L('Booking and scheduling engine', 'Rezervāciju un grafiku dzinējs'),
      L('Facility and member operations', 'Infrastruktūras un biedru operācijas'),
      L('Continuous feature delivery', 'Nepārtraukta funkciju piegāde'),
      L('Public and ops-facing surfaces', 'Publiskās un ops saskarnes'),
    ],
    chips: [L('Sports ops', 'Sporta ops'), L('Bookings', 'Rezervācijas')],
    cta: L('View platform', 'Skatīt platformu'),
    url: 'https://fullcourt.eu/en',
    cats: ['Platforms'],
    src: '/assets/portfolio/fullcourt-home.jpg',
    gallery: [
      '/assets/portfolio/fullcourt-home.jpg',
      '/assets/portfolio/extra/fullcourt-scroll.jpg',
      '/assets/portfolio/extra/fullcourt-features.jpg',
    ],
  },
  {
    key: 'trukka',
    title: 'Trukka',
    kind: 'Product',
    note: L('IN DEVELOPMENT', 'IZSTRĀDĒ'),
    blurb: L(
      'Transport product with web ops and mobile apps — jobs, dispatch, live maps, photos and statuses.',
      'Transporta produkts ar web ops un mobilajām lietotnēm — darbi, dispečers, dzīvā karte, foto un statusi.'
    ),
    about: L(
      'Trukka is a multi-company transport product: web console for company ops (jobs, customers, settlements, Stripe), customer and driver mobile apps (Expo / React Native), live location, photos, signatures and offline queue. Actively in development — web and mobile screenshots below.',
      'Trukka ir vairāku uzņēmumu transporta produkts: web konsole uzņēmuma ops (darbi, klienti, norēķini, Stripe), klienta un vadītāja mobilās lietotnes (Expo / React Native), dzīvā atrašanās vieta, foto, paraksti un offline rinda. Aktīvi izstrādē — zemāk web un mobile screenshoti.'
    ),
    solves: L(
      'One product for the whole transport job — web dispatch and mobile field work share the same truth.',
      'Viens produkts visam pārvadājumam — web dispečers un mobilais lauka darbs redz vienu un to pašu.'
    ),
    features: [
      L('Web ops console — jobs, customers, settlements', 'Web ops konsole — darbi, klienti, norēķini'),
      L('Driver and customer mobile apps', 'Vadītāja un klienta mobilās lietotnes'),
      L('Live driver location and maps', 'Vadītāja atrašanās vieta dzīvajā kartē'),
      L('Photos, signatures and offline queue', 'Foto, paraksti un offline rinda'),
      L('Multi-company, role-aware access', 'Vairāku uzņēmumu, lomu balstīta piekļuve'),
    ],
    chips: [
      L('Web', 'Web'),
      L('iOS · Android', 'iOS · Android'),
      L('Live maps', 'Dzīvā karte'),
      L('In development', 'Izstrādē'),
    ],
    cta: L('Coming soon', 'Drīzumā'),
    ctaMuted: true,
    cats: ['Products', 'Mobile', 'In development'],
    // Web dispatch as card hero (landscape); mobile shots use contain via /mobile/ path in CasePanel.
    src: '/assets/portfolio/trukka/web-dispatch.jpg',
    gallery: [
      '/assets/portfolio/trukka/web-dispatch.jpg',
      '/assets/portfolio/trukka/web-admin-dashboard.jpg',
      '/assets/portfolio/trukka/web-admin-jobs.jpg',
      '/assets/portfolio/trukka/web-admin-job.jpg',
      '/assets/portfolio/trukka/web-admin-job-create.jpg',
      '/assets/portfolio/trukka/web-admin-settlements.jpg',
      '/assets/portfolio/trukka/web-admin-users.jpg',
      '/assets/portfolio/trukka/web-company-stripe.jpg',
      '/assets/portfolio/trukka/web-customer-checkout.jpg',
      '/assets/portfolio/trukka/web-homepage.jpg',
      '/assets/portfolio/trukka/web-landing.jpg',
      '/assets/mobile/trukka/01-login.png',
      '/assets/mobile/trukka/02-customer-jobs.jpg',
      '/assets/mobile/trukka/03-customer-driver-map.jpg',
      '/assets/mobile/trukka/04-driver-active-job.jpg',
      '/assets/mobile/trukka/05-driver-workflow.jpg',
      '/assets/mobile/trukka/06-driver-live-location.jpg',
      '/assets/mobile/trukka/07-android-driver-lifecycle.png',
      '/assets/mobile/trukka/08-android-driver-completed.png',
      '/assets/mobile/trukka/09-android-customer-job.png',
      '/assets/mobile/trukka/10-android-company-setup.png',
      '/assets/mobile/trukka/marketing-driver-app.png',
    ],
  },
  {
    key: 'attendance',
    title: 'College Attendance',
    kind: 'Mobile',
    note: L('UK COLLEGES', 'UK KOLEDŽAS'),
    blurb: L(
      "Staff Android app for multi-college class registers — college select, today's classes and attendance.",
      'Android lietotne koledžu personālam — koledžas izvēle, šodienas nodarbības un apmeklējuma reģistri.'
    ),
    about: L(
      'Companion mobile layer for UK multi-college school management: staff pick a college, see today’s classes and mark attendance. Complements the long-running campus systems we operate for college groups.',
      'Mobilais slānis UK vairāku koledžu skolu pārvaldībai: personāls izvēlas koledžu, redz šodienas nodarbības un atzīmē apmeklējumu. Papildina ilgtermiņa campus sistēmas, ko darbinām koledžu grupām.'
    ),
    solves: L(
      'Class registers without paper — for staff across college groups.',
      'Apmeklējuma reģistri bez papīra — personālam vairākās koledžās.'
    ),
    features: [
      L("College select and today's classes", 'Koledžas izvēle un šodienas nodarbības'),
      L('One-tap attendance register', 'Reģistrs ar vienu pieskārienu'),
      L('Syncs with the school management system', 'Sinhronizējas ar skolu pārvaldības sistēmu'),
      L('Built for multi-campus staff workflows', 'Veidota vairāku kampusu personāla plūsmām'),
    ],
    chips: [L('Android', 'Android'), L('Multi-college', 'Multi-college'), L('Education', 'Izglītība')],
    cta: L('Details', 'Vairāk'),
    cats: ['Mobile', 'Education'],
    src: '/assets/mobile/attendance/02-todays-classes.png',
    fit: 'contain',
    gallery: [
      '/assets/mobile/attendance/01-login-college-select.png',
      '/assets/mobile/attendance/02-todays-classes.png',
      '/assets/mobile/attendance/03-attendance-register.png',
      '/assets/mobile/attendance-classes.png',
      '/assets/mobile/attendance-register.png',
    ],
  },
  {
    key: 'lusiic',
    title: 'LUSIIC',
    kind: 'Collaboration',
    note: L('PARTNER', 'PARTNERIS'),
    blurb: L(
      'Membership and institutional systems — University of Latvia.',
      'Biedru un institucionālās sistēmas — Latvijas Universitāte.'
    ),
    about: L(
      'Institutional collaboration around membership and organisation processes, delivered with University of Latvia context. Focus on registry and workflows rather than a marketing site alone.',
      'Institucionāla sadarbība ap biedru un organizācijas procesiem Latvijas Universitātes kontekstā. Uzsvars uz reģistru un darba plūsmām, ne tikai marketing vietni.'
    ),
    solves: L(
      'Membership records and institutional processes in one system.',
      'Biedru dati un institucionālie procesi vienā sistēmā.'
    ),
    features: [
      L('Member registry and statuses', 'Biedru reģistrs un statusi'),
      L('Institutional workflows', 'Institucionālās darba plūsmas'),
      L('Partner delivery with LU context', 'Partneru piegāde LU kontekstā'),
    ],
    chips: [L('Membership', 'Biedri'), L('Education', 'Izglītība')],
    cta: L('Details', 'Vairāk'),
    cats: ['Collaborations', 'Education'],
    panelImg: '/assets/logos/lu-university.svg',
    // Logo-forward only — no weak/bare login screenshot in portfolio.
    gallery: ['/assets/logos/lu-university.svg'],
  },
  {
    key: 'luogre',
    title: L('Education events — LU · Ogre', 'Izglītības pasākumi — LU · Ogre'),
    kind: 'Collaboration',
    note: L('PUBLIC SECTOR', 'PUBLISKAIS SEKTORS'),
    blurb: L(
      'Conference and education event platforms with the University of Latvia and Ogre municipality.',
      'Konferenču un izglītības pasākumu platformas ar Latvijas Universitāti un Ogres novadu.'
    ),
    about: L(
      'Public-sector collaboration: education conference and event platforms for University of Latvia and Ogre municipality initiatives — programmes, speakers and registration that hold up on event day.',
      'Publiskā sektora sadarbība: izglītības konferenču un pasākumu platformas LU un Ogres novada iniciatīvām — programma, runātāji un reģistrācija, kas iztur pasākuma dienu.'
    ),
    solves: L(
      'Event platforms that survive registration day.',
      'Pasākumu platformas, kas iztur reģistrācijas dienu.'
    ),
    features: [
      L('Programme, speakers and registration', 'Programma, runātāji un reģistrācija'),
      L('Built for public-sector partners', 'Veidotas publiskā sektora partneriem'),
      L('University and municipal collaboration', 'Universitātes un pašvaldības sadarbība'),
    ],
    chips: [L('Events', 'Pasākumi'), L('Education', 'Izglītība')],
    cta: L('Details', 'Vairāk'),
    url: 'https://onizglitiba.lv',
    cats: ['Collaborations', 'Education'],
    src: '/assets/portfolio/onizglitiba-home.jpg',
    gallery: [
      '/assets/portfolio/onizglitiba-home.jpg',
      '/assets/portfolio/extra/onizglitiba-scroll.jpg',
      '/assets/portfolio/extra/onizglitiba-news.png',
      '/assets/logos/lu-university.svg',
      '/assets/logos/ogre-novads.png',
      '/assets/logos/onizglitiba.png',
    ],
  },
  {
    key: 'signet',
    title: 'Signet Contemporary Art',
    kind: 'Collaboration',
    note: L('EARLIER WORK', 'AGRĀKS DARBS'),
    blurb: L('Gallery web presence and digital showcase.', 'Galerijas tīmekļa klātbūtne un digitālā vitrīna.'),
    about: L(
      'Earlier collaboration: gallery web presence focused on presenting artworks and enabling enquiries. Shown as past work alongside newer product platforms.',
      'Agrāka sadarbība: galerijas tīmekļa klātbūtne ar uzsvaru uz darbiem un pieprasījumiem. Rādīta kā agrāks darbs blakus jaunākiem produktu platformām.'
    ),
    solves: L('A gallery presence that puts the art first.', 'Galerijas klātbūtne, kur māksla ir pirmajā vietā.'),
    features: [
      L('Artwork showcase', 'Darbu vitrīna'),
      L('Enquiries to the gallery', 'Pieprasījumi galerijai'),
      L('Responsive gallery experience', 'Responsīva galerijas pieredze'),
    ],
    chips: [L('Web', 'Web')],
    cta: L('View site', 'Skatīt vietni'),
    url: 'https://signetcontemporaryart.com',
    cats: ['Collaborations'],
    src: '/assets/portfolio/signet-home.png',
    gallery: ['/assets/portfolio/signet-home.png'],
    earlier: true,
  },
  {
    key: 'everlasting',
    title: 'Everlasting Brows',
    kind: 'Collaboration',
    note: L('EARLIER WORK', 'AGRĀKS DARBS'),
    blurb: L('Beauty e-commerce storefront.', 'Skaistumkopšanas e-komercijas vietne.'),
    about: L(
      'Earlier e-commerce collaboration for a beauty brand: catalogue, checkout and brand content. Quiet “past work” entry next to current product portfolio.',
      'Agrāka e-komercijas sadarbība skaistumkopšanas zīmolam: katalogs, pirkuma plūsma un zīmola saturs. Klusa “agrākā darba” pozīcija blakus aktuālajam produktu portfolio.'
    ),
    solves: L(
      "E-commerce for a beauty brand's product line.",
      'E-komercija skaistumkopšanas zīmola produktiem.'
    ),
    features: [
      L('Product catalogue and checkout', 'Produktu katalogs un pirkuma plūsma'),
      L('Brand-managed content', 'Zīmola pārvaldīts saturs'),
      L('Responsive storefront', 'Responsīvs veikals'),
    ],
    chips: [L('E-commerce', 'E-komercija')],
    cta: L('View site', 'Skatīt vietni'),
    url: 'https://everlastingbrows.com',
    cats: ['Collaborations', 'E-commerce'],
    src: '/assets/portfolio/everlastingbrows-home.png',
    gallery: ['/assets/portfolio/everlastingbrows-home.png'],
    earlier: true,
  },
  {
    key: 'fieldledger',
    title: 'FieldLedger',
    kind: 'Product',
    note: L('PILOT OPEN', 'PILOTS ATVĒRTS'),
    blurb: L(
      'Web platform for agronomy teams — farms, field boundaries, soil analyses and recommendations.',
      'Web platforma agronomu komandām — saimniecības, lauku robežas, augsnes analīzes un ieteikumi.'
    ),
    about: L(
      'Web product for agronomy consultancies: browser-based map and ops UI for farms and field boundaries, soil analyses linked to fields, zone maps, liming advice and recommendation history. Public name FieldLedger only — screenshots use neutral product chrome and demo data.',
      'Web produkts agronomu konsultācijām: pārlūkā balstīta karte un ops UI saimniecībām un lauku robežām, augsnes analīzes piesaistītas laukiem, zonu kartes, kaļķošanas ieteikumi un vēsture. Publiski tikai FieldLedger — screenshotos neitrāls produkta UI un demo dati.'
    ),
    solves: L(
      'Field knowledge in one web ledger — instead of folders, emails and memory.',
      'Lauku zināšanas vienā web reģistrā — mapju, e-pastu un atmiņas vietā.'
    ),
    features: [
      L('Web map of farms and field boundaries', 'Web karte — saimniecības un lauku robežas'),
      L('Soil analyses linked to fields', 'Augsnes analīzes piesaistītas laukiem'),
      L('Zone maps and liming recommendations', 'Zonu kartes un kaļķošanas ieteikumi'),
      L('Pilot programme open for advisory teams', 'Pilota programma atvērta konsultāciju komandām'),
    ],
    chips: [
      L('Web', 'Web'),
      L('Agronomy', 'Agronomija'),
      L('Maps', 'Kartes'),
      L('In development', 'Izstrādē'),
    ],
    cta: L('Contact for pilot', 'Pieteikties pilotam'),
    ctaColor: '#B45309',
    cats: ['Products', 'In development'],
    src: '/assets/portfolio/fieldledger/05-map.jpg',
    gallery: [
      '/assets/portfolio/fieldledger/05-map.jpg',
      '/assets/portfolio/fieldledger/01-dashboard.jpg',
      '/assets/portfolio/fieldledger/11-home.jpg',
      '/assets/portfolio/fieldledger/03-clients.jpg',
      '/assets/portfolio/fieldledger/04-fields-list.jpg',
      '/assets/portfolio/fieldledger/12-fields-table.jpg',
      '/assets/portfolio/fieldledger/06-field-detail-samples.jpg',
      '/assets/portfolio/fieldledger/07-field-detail-full.jpg',
      '/assets/portfolio/fieldledger/08-zone-map.jpg',
      '/assets/portfolio/fieldledger/09-liming.jpg',
      '/assets/portfolio/fieldledger/10-soil-import.jpg',
      '/assets/portfolio/fieldledger/13-map-polygons.jpg',
      '/assets/portfolio/fieldledger/14-map-farm.jpg',
      '/assets/portfolio/fieldledger/02-login.jpg',
    ],
  },
];

export const PRODUCT_HOME_KEYS = [
  'classreflect',
  'eladore',
  'sellgames',
  'invoicesuite',
  'findstorage',
  'quiz',
  'ticketflow',
  'evertejumi',
  'trukka',
  'fieldledger',
];

export function localize(value, lang) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && (value.en != null || value.lv != null)) {
    return lang === 'lv' ? value.lv || value.en : value.en || value.lv;
  }
  return String(value);
}

function localizeMetric(metric, lang) {
  if (!metric) return null;
  return {
    value: metric.value,
    label: localize(metric.label, lang),
  };
}

export function localizeItem(item, lang) {
  const evidence = portfolioEvidence[item.key] || {};
  const metric = item.metric || evidence.metric;
  const techStack = item.techStack || evidence.techStack || [];

  return {
    ...item,
    title: localize(item.title, lang),
    note: localize(item.note, lang),
    blurb: localize(item.blurb, lang),
    about: localize(item.about, lang),
    solves: localize(item.solves, lang),
    features: (item.features || []).map((f) => localize(f, lang)),
    chips: (item.chips || []).map((c) => localize(c, lang)),
    metric: localizeMetric(metric, lang),
    techStack: techStack.map((s) => localize(s, lang)),
    cta: localize(item.cta, lang),
    gallery: item.gallery && item.gallery.length ? item.gallery : item.src ? [item.src] : [],
  };
}

export function portfolioExperienceEntries(lang = 'en') {
  return portfolioItems.map((item) => {
    const d = localizeItem(item, lang);
    return {
      key: d.key,
      title: d.title,
      kind: d.kind,
      summary: d.blurb,
      result: d.metric ? `${d.metric.value} ${d.metric.label}` : '',
      techStack: d.techStack,
      features: d.features,
    };
  });
}
